import {
  Control,
  FieldError,
  UseFormClearErrors,
  UseFormGetValues,
  UseFormSetError,
  UseFormSetValue,
} from 'react-hook-form';

import { AddTemplateFormSchema } from '../validations/add-template.validation';

export type StepContentProps = {
  clearErrors: UseFormClearErrors<AddTemplateFormSchema>;
  control: Control<AddTemplateFormSchema>;
  excludeTemplateId?: string;
  getFieldError: () => FieldError | undefined;
  getValues: UseFormGetValues<AddTemplateFormSchema>;
  setError: UseFormSetError<AddTemplateFormSchema>;
  setValue: UseFormSetValue<AddTemplateFormSchema>;
};

export type TemplateStep = 1 | 2 | 3 | 4;

export type StepOneFieldErrors = { stepOne?: { name?: FieldError } };

const hasStepOneNameError = (obj: unknown): obj is { name?: FieldError } =>
  obj != null && typeof obj === 'object' && 'name' in obj;

export const getStepOneNameError = (
  errors: { stepOne?: unknown } | undefined,
): FieldError | undefined => {
  const stepOne = errors?.stepOne;
  return hasStepOneNameError(stepOne) ? stepOne.name : undefined;
};
